// extracted by mini-css-extract-plugin
module.exports = {"navigation-bar":"navigation-tabs-module__navigation-bar__3LnS2","active-tab":"navigation-tabs-module__active-tab__2GG21"};